module.exports = __webpack_public_path__ + "static/img/title-banner1-type4.c5a7ec4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/2/title-banner1-type4.png
// module id = aS4a
// module chunks = 1